import { createActionWithPayload, createAction } from 'actions/utils';

export const ACTIONS = {
  SET_QUESTION_WIDGET_HEIGHT: 'SET_QUESTION_WIDGET_HEIGHT',
  CLEAR_QUESTION_WIDGET_HEIGHT: 'CLEAR_QUESTION_WIDGET_HEIGHT',
} as const;

export const setWidgetsHeight = createActionWithPayload<
  typeof ACTIONS.SET_QUESTION_WIDGET_HEIGHT,
  { widgetsHeight: Record<string, number> }
>(ACTIONS.SET_QUESTION_WIDGET_HEIGHT);

export const clearWidgetsHeight = createAction<
  typeof ACTIONS.CLEAR_QUESTION_WIDGET_HEIGHT
>(ACTIONS.CLEAR_QUESTION_WIDGET_HEIGHT);
